"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    width: "100%",
    paddingRight: theme.spacing(3),
    alignItems: "center",
    justifyContent: "start",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    lineHeight: "24px",
    color: theme.palette.text.secondary,
    "&[aria-selected=true]": {
      "& $label": {
        color: theme.palette.text.primary,
        color: theme.palette.type === "dark" && theme.palette.primary.light || theme.palette.primary.dark
      }
    }
  },
  icon: {
    "&[aria-selected=true]": {
      color: theme.palette.text.primary
    }
  },
  label: {
    display: "block",
    width: "100%",
    flexBasis: "100%",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    paddingLeft: "12px",
    paddingRight: "6px"
  },
  count: {
    position: "absolute",
    right: 0,
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "24px",
    textAlign: "right",
    color: theme.palette.text.secondary
  }
}));

const MenuLink = ({
  className,
  selected,
  icon,
  label,
  title,
  count,
  onClick,
  children
}) => {
  const classes = useStyles();

  if (!label && title) {
    label = title;
  }

  let color;

  if (selected) {
    color = "primary";
  }

  return _react.default.createElement(_ButtonBase.default, {
    color: color,
    className: className || classes.root,
    "aria-selected": selected,
    onClick: onClick
  }, icon && _react.default.createElement(_Icon.default, {
    className: classes.icon,
    "aria-selected": selected
  }, icon), label && _react.default.createElement(_Typography.default, {
    component: "b",
    align: "left",
    noWrap: true,
    className: classes.label
  }, label), count && _react.default.createElement(_Typography.default, {
    component: "i",
    align: "right",
    nowrap: "true",
    className: classes.count
  }, count), children);
};

var _default = MenuLink;
exports.default = _default;
module.exports = exports.default;